<template>
  <div class="views">
    <div class="bodys"></div>

    <!--   登录   -->
    <div class="bodyBox">
      <!--    账号登录      -->
      <div class="bodyBox1" v-show="types == '1'">
        <h1>HRO管理系统</h1>
        <el-input
          type="text"
          v-model.trim="formLabelAlign.username"
          placeholder="请输入登录账号"
          maxlength="11"
        ></el-input>
        <el-input
          type="password"
          v-model.trim="formLabelAlign.pass"
          placeholder="请输入登录密码"
          maxlength="16"
          auto-complete="off"
          class="password"
        ></el-input>

        <div class="flax_x">
          <el-input
            type="text"
            placeholder="请输入验证码"
            v-model.trim="formLabelAlign.code"
            class="code"
          />
          <img :src="vsCode" alt class="imgFl" @click="changeCodeImg()" />
        </div>

        <div class="tipsInfos">{{ tipsInfo }}</div>

        <div @click="login">
          <el-button type="button" @keyup.enter.native="login" class="foot-btn">
            登 &nbsp;&nbsp;&nbsp; 录
          </el-button>
        </div>

        <!--    忘记密码 暂时隐藏       -->
        <!--            <div class="forgetTxt" @click="handForget">忘记密码?</div>-->

        <!--自定义loading   -->
        <div v-if="loginLoading" class="el-loading-mask loadingClass">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
      <div class="bodyBox2" v-show="types == '2'">
        <i
          class="el-icon-back go-back"
          @click="
            types = '1';
            loginLoading = false;
          "
        ></i>
        <div style="font-size: 18px;">请选择要登录的机构</div>
        <div class="list">
          <div v-for="(item, index) in institutionList" :key="index">
            <div v-if="item.list.length > 0">
              <div>{{ item.name }}</div>
              <div
                class="list-con"
                v-for="(el, lindex) in item.list"
                :key="lindex"
                @click="doLogin(el)"
              >
                {{ el.objName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--    找回密码      -->
      <div class="bodyBox3" v-show="types == '3'">
        <div>忘记密码</div>
        <div @click="backLogin">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="forgetPSWContent">
          <el-input
            type="text"
            v-model.trim="setData.phone"
            placeholder="请输入手机号"
            @input="
              (value) => {
                setData.phone = value.replace(/[^\d]/g, '');
              }
            "
            maxlength="11"
          ></el-input>
          <div class="linePSW">
            <el-input
              type="text"
              v-model.trim="setData.phoneCode"
              placeholder="请输入验证码"
              maxlength="11"
            ></el-input>
            <span
              class="getCode"
              @click="handelGetCode"
              v-if="phoneCode == '1001'"
              >获取验证码
            </span>
            <span
              class="getCode"
              :class="disabledCode == '3001' ? '' : 'disableSpan'"
              @click="handelGetCode"
              v-if="phoneCode == '1002'"
            >
              重新获取 <span v-if="codeShow == 2001">({{ timers }})</span>
            </span>
          </div>
          <div @click="retrievePSW">
            <el-button type="button" class="foot-btn3">找回密码</el-button>
          </div>
        </div>
      </div>

      <!--    保存更改      -->
      <div class="bodyBox3" v-show="types == '4'">
        <div>找回密码</div>
        <div @click="backLogin">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="forgetPSWContent">
          <el-input
            type="password"
            v-model.trim="setData.password"
            placeholder="设置密码"
          ></el-input>
          <el-input
            type="password"
            v-model.trim="setData.again"
            placeholder="确认密码"
          ></el-input>
          <div style="margin-top: 25px;">
            <el-button
              class="foot-btn3"
              type="button"
              @click="preservationSetPsw"
              >保存修改
            </el-button>
          </div>
        </div>
      </div>

      <!--    马上登录      -->
      <div class="bodyBox4" v-show="types == '5'">
        <div>找回密码</div>
        <div class="pswInfo">
          您已经成功设置密码，3秒后系统将自动跳转到
          <span @click="backLogin">登录页面</span>
        </div>
        <div>
          <el-button class="foot-btn4" type="button" @click="backLogin"
            >马上登录</el-button
          >
        </div>
      </div>
    </div>

    <!--   京ICP备   -->
    <div class="foot_ddd">
      <span class="foot_son"><a href=""></a></span>
    </div>
  </div>
</template>
<script>
//背景
import "../../assets/css/loginStar.css";

import https from "../../plugins/https";
import { EncryptData, DecryptData } from "../../assets/js/aes";
import axios from "axios";

export default {
  data() {
    return {
      list: [
        {
          name:
            "能接受的肯定就是咖啡和科技示范户收到货后数据库或多或少就只能靠回复",
        },
        { name: "能接受的" },
        { name: "能接受的" },
        // {name:"能接受的"},
        // {name:"能接受的"},
      ],
      phoneCode: "1001", //获取验证码//重新获取
      loginType: "0001", //0001代表的是登录  0002代表的是忘记密码
      codeShow: "2001", //判断倒计时是否显示
      disabledCode: "3001", //判断获取验证码是否能点击
      setPswId: "",
      // 获取验证码的手机号
      // phone: "",
      types: 1,
      tipsInfo: "",
      labelPosition: "right",
      num: "",
      vsCode: "",
      formLabelAlign: {
        pass: "",
        username: "",
        code: "",
      },
      setData: {
        phone: "", //手机号
        id: "", //选择渠道的id
        phoneCode: "", //验证码
        password: "", //密码
        again: "", //再次输入密码
      },
      second: 60, //倒计时的秒数
      bools: false,
      dialogVisible: false,
      phone: "", //忘记密码  手机号
      verification: "", //忘记密码 验证码
      psw: "", //修改后的密码
      timers: 60,
      findPswTime: null,
      loginLoading: false,
      headersAppTag: "",
      institutionList: [], // 机构list
    };
  },
  // 这里改了
  created() {
    var that = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key === 13) {
        that.login(); // 触发事件
      }
    };
    let userName = localStorage.getItem("username");
    if (userName && userName != "") {
      this.formLabelAlign.username = userName;
    }
    this.formLabelAlign.code = "";
  },
  mounted: function() {
    window.scrollTo(0, 0);
    const _this = this;
    _this.changeCodeImg();
    var token = localStorage.getItem("token");
    if (token) this.$router.push({ path: "/homePage" });
  },
  methods: {
    but() {
      // EncryptData("大家好")
      let data = "jdsfhjdsk";
      let loh = EncryptData(data);
      console.log(loh);
      // setTimeout(()=>{
      console.log(DecryptData("t8RTbhsJHWgeBcEYfR/GpA=="));
      // },1000)
    },
    // $("#asd").hover(function{

    // }),
    //找回密码
    findPSW() {
      this.loginType = "0002";
      this.types = 2;
    },
    // 获取验证码
    handelGetCode() {
      if (this.setData.phone != "" && this.setData.phone.length > 0) {
        if (this.disabledCode == "3001") {
          https
            .getCode({ phone: this.setData.phone })
            .then((res) => {
              console.log(res);
              if (res.data.code == "0000") {
                this.codeShow = "2001";
                console.log(res);
                this.phoneCode = "1002";
                this.disabledCode = "3002";
                this.findPswTime = setInterval(() => {
                  if (this.timers > 0) {
                    this.timers -= 1;
                  } else {
                    this.codeShow = "2002";
                    this.disabledCode = "3001";
                    this.timers = 60;
                    clearInterval(this.findPswTime);
                  }
                }, 1000);
              } else {
                layer.open({
                  content: res.data.msg,
                  skin: "msg",
                  time: 1, //1秒后自动关闭
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      } else {
        layer.open({
          content: "请输入手机号",
          skin: "msg",
          time: 1, //1秒后自动关闭
        });
      }
    },
    // 找回密码
    retrievePSW() {
      if (this.setData.phone != "" && this.setData.phoneCode != "") {
        https
          .getUser({
            phone: this.setData.phone,
            phoneCode: this.setData.phoneCode,
          })
          .then((res) => {
            console.log("获取出来的用户信息");
            console.log(res);
            if (res.data.code == "0000") {
              this.list = res.data.data;
              this.loginType = "0002";
              this.types = 2;
            } else {
              layer.open({
                content: res.data.data.msg,
                skin: "msg",
                time: 1, //1秒后自动关闭
              });
            }
            return;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        layer.open({
          content: "手机号和验证码不能为空",
          skin: "msg",
          time: 1, //1秒后自动关闭
        });
      }

      // 这里需要发送一个请求

      // 如果只有一个渠道的时候 types变成4
      // this.types = 4;
      // 如果有多个的话  那么就让去选择修改哪个渠道的密码
    },
    // 保存修改的密码
    preservationSetPsw() {
      // this.types = 5;
      if (this.setData.password != "" || this.setData.again != "") {
        if (this.setData.password == this.setData.again) {
          https
            .confirmSetPsw(this.setData)
            .then((res) => {
              console.log("保存修改的密码状态");
              if (res.data.code == "0000") {
                layer.open({
                  content: res.data.msg,
                  skin: "msg",
                  time: 1, //1秒后自动关闭
                });

                this.types = 5;
                this.setData.phoneCode = "";
                this.setData.phone = "";
                this.setData.id = "";
                this.setData.password = "";
              } else {
                return;
              }
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          layer.open({
            content: "两次输入密码不一致",
            skin: "msg",
            time: 1, //1秒后自动关闭
          });
        }
      } else {
        layer.open({
          content: "密码输入不能为空",
          skin: "msg",
          time: 1, //1秒后自动关闭
        });
      }
    },
    guan() {
      // window.location.href = "about:blank";
      window.close();
    },

    // 获取验证码
    handCode() {
      console.log("获取验证码");

      if (!/^1[34578]\d{9}$/.test(this.phone)) {
        console.log("手机号码有误，请重填");
        this.$alert("手机号输入有误", "提示", {
          confirmButtonText: "确定",
        });
        return false;
      } else {
        console.log("进入这里");
        this.bools = true;
        let timer = setInterval(() => {
          console.log("进入定时器");
          if (this.second > 0) {
            this.second--;
          } else {
            this.bools = false;
            this.second = 60;
            clearInterval(timer);
          }
        }, 1000);
        console.log("手机号正确");
        return true;
      }
    },
    // 重置密码
    resetPsw() {
      if (!/^1[34578]\d{9}$/.test(this.phone)) {
        this.$alert("手机号输入有误", "提示", {
          confirmButtonText: "确定",
        });
      } else if (this.verification == "") {
        this.$alert("验证码不能为空", "提示", {
          confirmButtonText: "确定",
        });
      } else if (this.psw.length < 8) {
        this.$alert("密码最少8位", "提示", {
          confirmButtonText: "确定",
        });
      } else {
      }
    },
    // 普通代理登录
    into(val) {
      // 判断是从哪里过来的
      // 如果是登录过来的话，那么就走登录
      // 如果是找回密码得话，那么就types变成2

      // 0001走的是登录
      if (this.loginType == "0001") {
        console.log(val);
        this.$axios({
          method: "post",
          url: "/api/affirmLogin",
          data: {
            uid: val.uid,
            oldPassword: val.oldPassword,
            username: val.username,
          },
        })
          .then((res) => {
            if (res.data.code == "0000") {
              //临时转存
              this.headersAppTag = localStorage.getItem("headersAppTag");
              //清除所有localStorage
              localStorage.clear();
              localStorage.setItem("headersAppTag", this.headersAppTag);
              console.log(res.data.data);
              localStorage.setItem("uid", res.data.data.uid); //uid
              localStorage.setItem("token", res.data.token); //token
              localStorage.setItem("appTag", res.data.data.appTag);
              // 存放系统用户名称
              localStorage.setItem("sysUserName", res.data.data.sysUserName);
              // 邀请码
              localStorage.setItem("developCode", res.data.data.developCode);
              localStorage.setItem(
                "authenticationStatus",
                res.data.data.authenticationStatus
              );
              this.$store.state.token = res.data.token;
              res.data.data.agtType == "ADM"
                ? (res.data.data.agtType = 2)
                : res.data.data.agtType;
              localStorage.setItem("jurisdiction", res.data.data.agtType); //权限字段
              localStorage.setItem("name", res.data.data.name);

              this.tipsInfo = "登录成功";
              this.$router.push({
                path: "/homePage",
              });
              this.$notify({
                title: "登录成功",
                message: "欢迎登录管理系统",
                offset: 50,
                type: "success",
              });
            } else {
              layer.open({
                content: res.data.msg,
                skin: "msg",
                time: 2, //2秒后自动关闭
              });
            }
          })
          .catch((err) => {});
      } else {
        console.log(val);
        this.types = 4;
        this.setPswId = val.id;
        this.setData.id = val.id;
      }
    },
    handLogo() {
      this.dialogVisible = false;
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    /**** 获取验证码  ***/

    changeCodeImg() {
      var _this = this;
      _this.num = Math.ceil(Math.random() * 1000000);
      //_this.vsCode = _this.urltype + '/api/vsCode.jpg',
      console.log(this.GLOBAL);
      _this.vsCode = this.GLOBAL.httpurl + "/api/captcha.jpg?uuid=" + _this.num;
    },

    /**** 登录账号  密码   验证码 ****/

    login() {
      this.loginType = "0001";
      let userName = localStorage.setItem(
        "username",
        this.formLabelAlign.username
      );

      // var myreg=/^1[34578]\d{9}$/;
      if (this.formLabelAlign.username == "") {
        this.openPhone();
        return false;
      }

      if (this.formLabelAlign.pass == "") {
        this.openPass();
        return false;
      }

      if (this.formLabelAlign.code == "") {
        this.openCode();
        return false;
      }
      this.loginLoading = true;

      // this.$axios({
      //     method: "post",
      //     url: "api/login",
      //     data: {
      //         username: this.formLabelAlign.username,
      //         password: this.formLabelAlign.pass,
      //         captcha: this.formLabelAlign.code,
      //         uuid: this.num,
      //     },
      // })

      axios
        .post("api/getLoginInfoList", {
          loginAccount: this.formLabelAlign.username,
        })
        .then((res) => {
          const { code, data, msg } = res.data;
          if (code === 200) {
            if (data.length > 1) {
              const institutionList = [
                {
                  name: "机构",
                  list: [],
                },
                {
                  name: "签约公司",
                  list: [],
                },
                {
                  name: "企业",
                  list: [],
                },
              ];
              data.forEach((item) => {
                institutionList[item.objType].list.push(item);
              });
              this.institutionList = institutionList;
              this.types = 2;
            } else {
              const [item] = data;
              this.doLogin({ objUid: item.objUid, objType: item.objType });
            }
          } else {
            layer.open({
              content: msg,
              skin: "msg",
              time: 1, //1秒后自动关闭
            });
          }
        });
    },
    doLogin(item) {
      axios
        .post("api/login", {
          loginAccount: this.formLabelAlign.username,
          password: this.formLabelAlign.pass,
          objUid: item.objUid,
          objType: item.objType,
          captcha: this.formLabelAlign.code,
          uuid: this.num,
        })
        .then((res) => {
          console.log(res);

          if (localStorage.getItem("appTag")) {
            localStorage.removeItem("appTag");
          }

          if (res.data.code == "0000") {
            //临时转存
            this.headersAppTag = localStorage.getItem("headersAppTag");
            //清除所有localStorage
            localStorage.clear();
            localStorage.setItem("loginUserInfo", JSON.stringify(res.data));
            //存储
            localStorage.setItem("headersAppTag", this.headersAppTag);

            // 存放apptag
            // if (this.formLabelAlign.username != 'admin') {
            //   localStorage.setItem("appTag", res.data.data.appTag)
            // }
            // 存放objType
            localStorage.setItem("objType", res.data.objType);
            localStorage.setItem("objUid", res.data.objUid);
            //存放token
            localStorage.setItem("uid", res.data.objUid); //uid
            localStorage.setItem("loginUserId", res.data.data.id); //loginUserId
            localStorage.setItem("token", res.data.token); //token
            // 存放系统用户名称
            localStorage.setItem("sysUserName", res.data.data.name);
            localStorage.setItem("loginAccount", res.data.data.loginAccount);
            if (res.data.objUser) {
              localStorage.setItem("userId", res.data.objUser.userId);
              localStorage.setItem("objUserId", res.data.objUser.id);
            }
            // 邀请码
            // localStorage.setItem("developCode", res.data.data.developCode);
            // localStorage.setItem(
            //     "authenticationStatus",
            //     res.data.data.authenticationStatus
            // );
            this.$store.state.token = res.data.token;
            res.data.data.agtType == "ADM"
              ? (res.data.data.agtType = 2)
              : res.data.data.agtType;
            localStorage.setItem("jurisdiction", res.data.data.agtType); //权限字段
            localStorage.setItem("name", res.data.data.name);

            this.tipsInfo = "登录成功";
            this.$router.push({
              path: "/homePage",
            });

            setTimeout(() => {
              this.loginLoading = false;
            }, 3000);

            this.$notify({
              title: "登录成功",
              message: "欢迎登录管理系统",
              offset: 50,
              type: "success",
            });
          } else {
            this.tipsInfo = res.data.msg;
            this.$notify({
              title: "登录失败",
              message: res.data.msg,
              offset: 50,
              type: "error",
            });
            this.changeCodeImg();
            this.loginLoading = false;
          }
        })
        .catch((err) => {
          this.loginLoading = false;
        });
    },
    // 想起密码
    backLogin() {
      console.log("------------");
      this.setData.phone = "";
      this.setData.phoneCode = "";
      this.phoneCode = "1001";
      this.timers = 60;
      this.disabledCode = "3001";
      clearInterval(this.findPswTime);
      this.types = 1;
    },
    backLogin1() {
      if (this.loginType == "0002") {
        this.types = 3;
      } else {
        this.types = 1;
      }
    },
    backLogin2() {
      this.types = 2;
    },
    // 暂不登录
    logins() {
      this.types = 1;
    },
    openPhone() {
      this.tipsInfo = "登录账号不能为空！";
    },
    openPass() {
      this.tipsInfo = "登录密码不能为空！";
    },
    openCode() {
      this.tipsInfo = "验证码不能为空！";
    },
    handForget() {
      this.types = 3;
    },
  },
  beforeDestroy() {
    this.tipsInfo = "";
  },
};
</script>
<style lang="less" scoped>
.views {
  background: url("../../assets/images/login/bg.png") no-repeat rgb(73, 78, 94);
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
}

.bodys {
  *:before,
  *:after {
    content: "";
    position: absolute;
  }

  .moon {
    /* 重置背景颜色 */
    background: #ffffff;
    /* 删除原有的背景属性 */
    background-image: none;
    box-shadow: none;
    position: absolute;
    width: 250vmax;
    height: 100vmax;
    z-index: 1;
    border-radius: 100%;
    background: radial-gradient(
        circle at 50% 50%,
        #fdfdfd 0% 5vmax,
        #ffffff00 10vmax 100%
      ),
      #fff;
    box-shadow: 0 0 5vmax 1vmax #6493a9, 0 0 5vmax 5vmax #adadad80 inset,
      0 0 2vmax 1vmax #fdfdfd;
    left: calc(50% - 125vmax);
    top: 44vmax;
  }

  .moon:before {
    content: "";
    background: radial-gradient(
      circle at 100% 60%,
      #ffffff00 0% 60%,
      #dddddd 75% 100%
    );
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0%;
    left: 0%;
    border-radius: 100%;
  }

  .crater {
    content: "";
    position: absolute;
    width: 25vmax;
    height: 20vmax;
    border-radius: 100%;
    transform: rotateX(50deg) rotateY(-10deg) rotateZ(15deg);
    border: 1px dotted #404040;
    background: linear-gradient(225deg, #000000, #eaeaea99);
    box-shadow: 0 0 3vmax 1vmax #585858, 0 0 0.5vmax 0.5vmax #5d5d5d,
      2vmax 5vmax 5.5vmax 3.5vmax #484848, 0 0 5vmax 0.5vmax #444444,
      1vmax 3.5vmax 1.5vmax 0.5vmax #ababab;
    left: calc(50% - 25vmax);
    opacity: 0.35;
    bottom: calc(50% + 25vmax);
  }

  /*** ASTRONAUT ***/

  .astronaut {
    width: 17vmax;
    height: 25.5vmax;
    right: -20vmax;
    position: absolute;
    top: 30vmax;
    z-index: 2;
    background: transparent;
    animation: walk-left 20s cubic-bezier(0.05, -0.01, 0.61, 0.99) 0s infinite,
      walk-up 5s cubic-bezier(0.35, 0.14, 1, 1) 1.5s infinite;
    margin-top: -12%;
  }

  @keyframes walk-left {
    0% {
      right: -20%;
    }
    20% {
      right: 10%;
    }
    45% {
      right: 40%;
    }
    70% {
      right: 70%;
    }
    100% {
      right: 100%;
    }
  }

  @keyframes walk-up {
    0%,
    100% {
      top: 30vmax;
    }
    10%,
    90% {
      top: 31vmax;
    }
    50% {
      top: 35vmax;
    }
  }

  .astronaut * {
    position: absolute;
  }

  .backpack {
    background: linear-gradient(
      91deg,
      #343535 0% 55%,
      #4b4e50 58% 75%,
      #6e7071 77% 88%,
      #c6c6c6 92% 100%
    );
    width: 30%;
    height: 38%;
    left: 57%;
    top: 20%;
    border-radius: 10% 17% 60% 10%;
    border-top: 0.2vmax solid #4b4e50;
  }

  .head {
    background: #b8b8b8;
    width: 46%;
    height: 27%;
    border-radius: 50%;
    left: 31%;
    top: 4%;
    border-bottom: 1vmax solid #9b9b9b;
    transform: rotate(-4deg);
    z-index: 3;
  }

  .head:before {
    width: 75%;
    height: 69%;
    border-radius: 50% 50% 0 0;
    left: 9%;
    top: 3%;
    border-top: 0.65vmax solid #c6c6c6;
    border-right: 0.15vmax solid transparent;
    border-left: 0.15vmax solid transparent;
    transform: rotate(9deg);
  }

  .head:after {
    background: radial-gradient(
      circle at 45% 25%,
      #2b2b2b 0 57%,
      #252525 58% 100%
    );
    width: 80%;
    height: 83%;
    border-radius: 50%;
    left: 5%;
    top: 13%;
    border: 0.25vmax solid #000;
    box-sizing: border-box;
  }

  .helmet {
    background: radial-gradient(circle at 8% 33%, #343434 0 5%, #fff0 6% 100%),
      radial-gradient(circle at 94% 42%, #343434 0 5%, #fff0 6% 100%),
      radial-gradient(circle at 25% 75%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 35% 70%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 45% 67%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 55% 69%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 65% 77%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 75% 87%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 85% 96%, #2b2b2b 0 35%, #fff0 36% 100%),
      radial-gradient(circle at 96% 49%, #2b2b2b 0 5%, #fff0 6% 100%),
      radial-gradient(circle at 4% 40%, #2b2b2b 0 5%, #fff0 6% 100%);
    width: 50%;
    height: 50%;
    border-radius: 100%;
    z-index: 3;
    left: 15%;
    top: 22%;
    transform: rotate(-16deg);
    color: #343434;
    color: #5d5d5d;
    background-color: #343434;
  }

  .helmet:before {
    background: #343434;
    width: 98%;
    height: 36%;
    border-radius: 100%;
    left: 2%;
    top: 25%;
    transform: rotate(5deg);
  }

  .helmet:after {
    background: #5d5d5d;
    width: 18%;
    height: 16%;
    border-radius: 100%;
    left: 58%;
    top: 14%;
    transform: rotate(27deg);
    box-shadow: -1.15vmax 0.35vmax 0vmax -0.2vmax #7a7a7a,
      -1.05vmax 0.25vmax 0vmax -0.2vmax #7a7a7a;
  }

  .neck {
    background: radial-gradient(
      circle at 43.95% 15%,
      transparent 0 61%,
      #666b6e 62% 100%
    );
    width: 48%;
    height: 10%;
    top: 17%;
    left: 30%;
    border-radius: 50% 50% 100% 100%;
    transform: rotate(5deg);
    z-index: 3;
  }

  .neck:before,
  .neck:after {
    background: linear-gradient(
        177deg,
        #fff0 0 32%,
        #9a9a9a 35% 40%,
        #fff0 50% 100%
      ),
      #676c6f;
    width: 80%;
    height: 100%;
    left: -44%;
    border-radius: 75% 35% 75% 100%;
    transform: rotate(15deg);
    top: -27%;
    opacity: 0;
  }

  .neck:after {
    left: 60%;
    transform: rotateY(180deg) rotateZ(10deg);
    top: -15%;
    border-radius: 40% 35% 75% 100%;
    background: linear-gradient(
        179deg,
        #fff0 0 30%,
        #9a9a9a 35% 45%,
        #fff0 47% 100%
      ),
      #676c6f;
  }

  .body {
    background: radial-gradient(
      circle at 50% -75%,
      #c6c6c6 0 80%,
      #5f5f5f 81% 85%,
      #c6c6c6 86% 100%
    );
    width: 45%;
    height: 30%;
    left: 32%;
    top: 31%;
    border-radius: 19% 23% 34% 37%;
    transform: rotate(-1deg);
    z-index: 2;
    border-right: 2vmax solid #888d90;
    box-sizing: border-box;
    border-bottom: 1vmax solid #888d90;
  }

  .body:before {
    background: radial-gradient(
        ellipse at 38% 65%,
        #888d90 0 13%,
        #fff0 15% 100%
      ),
      radial-gradient(ellipse at 33% 65%, #888d90 0 13%, #fff0 15% 100%),
      radial-gradient(ellipse at 28% 65%, #888d90 0 13%, #fff0 15% 100%),
      radial-gradient(ellipse at 38% 30%, #666b6e 0 13%, #fff0 15% 100%),
      radial-gradient(ellipse at 33% 30%, #666b6e 0 13%, #fff0 15% 100%),
      radial-gradient(ellipse at 28% 30%, #666b6e 0 13%, #fff0 15% 100%),
      radial-gradient(circle at 74% 30%, #f50000 0 11%, #fff0 12% 100%),
      radial-gradient(circle at 75% 65%, #4562ff 0 10%, #fff0 12% 100%),
      radial-gradient(circle at 75% 31%, #790000 0 11%, #fff0 12% 100%),
      radial-gradient(circle at 76% 66%, #6f0000 0 10%, #fff0 12% 100%), #d7d7d7;

    width: 65%;
    height: 41%;
    border-radius: 20%;
    top: 15%;
    left: 19%;
    transform: rotate(3deg);
    border-right: 0.25vmax solid #b1b1b1;
    border-bottom: 0.25vmax solid #adadad;
    border-left: 0.1vmax solid #b8b8b8;
    border-top: 0.15vmax solid #b8b8b8;
    box-sizing: border-box;
  }

  /*** ARMS ***/

  .arm {
    width: 40%;
    height: 18%;
    top: 25%;
    transform-origin: right center;
  }

  .arm.right {
    z-index: 0;
    left: -5%;
    transform: rotate(20deg);
    top: 27%;
    animation: arm-right 20s ease-out 0s infinite;
  }

  @keyframes arm-right {
    0% {
      transform: rotate(5deg);
    }
    20% {
      transform: rotate(-95deg);
    }
    45% {
      transform: rotate(5deg);
    }
    70% {
      transform: rotate(-95deg);
    }
    100% {
      transform: rotate(5deg);
    }
  }

  .arm.left {
    left: 31%;
    transform: rotate(-145deg);
    top: 28%;
    z-index: 4;
    animation: arm-left 20s ease-out 0s infinite;
  }

  @keyframes arm-left {
    0% {
      transform: rotate(-145deg);
    }
    20% {
      transform: rotate(-45deg);
    }
    45% {
      transform: rotate(-145deg);
    }
    70% {
      transform: rotate(-45deg);
    }
    100% {
      transform: rotate(-145deg);
    }
  }

  .arm .top {
    background: #0000ff70;
    width: 55%;
    height: 45%;
    right: 0;
    top: 33%;
    transform-origin: right center;
    transform: rotate(-13deg);
    border-radius: 40%;
    background: linear-gradient(-3deg, #888d90 0 40%, #c6c6c6 43% 100%);
  }

  .arm .bot {
    width: 55%;
    height: 45%;
    top: 53%;
    left: 15%;
    transform-origin: right center;
    transform: rotate(25deg);
    border-radius: 40%;
    background: radial-gradient(circle at 100% 51%, #888d90 0 7%, #fff0 8% 100%),
      linear-gradient(-3deg, #888d90 0 40%, #c6c6c6 43% 100%);
  }

  .arm > div:before {
    background: #666b6e;
    height: 1.75vmax;
    width: 1vmax;
    right: 5%;
    border-radius: 80% 70% 35% 30%;
    transform: rotate(-15deg);
    top: -20%;
  }

  .arm > div:after {
    background: #666b6e;
    height: 1.5vmax;
    width: 1vmax;
    top: 40%;
    right: 1%;
    transform: rotate(0deg);
    border-radius: 30% 30% 80% 70%;
  }

  .arm.right .top:before {
    transform: rotate(10deg);
    right: -2%;
  }

  .arm.left .top:before {
    transform: rotate(-2deg);
    left: 78%;
    right: 1%;
    top: -10%;
  }

  .arm.left .top:after {
    top: 45%;
    right: -1%;
    width: 21%;
  }

  /*** HANDS ***/

  .hand {
    background: #888d90;
    width: 33%;
    height: 53%;
    border-radius: 55%;
    top: 19%;
    transform: rotate(22deg);
    left: 2%;
  }

  .hand:before {
    top: -5% !important;
    right: -0.25vmax !important;
    transform: rotate(-5deg) !important;
  }

  .hand:after {
    top: 45% !important;
    right: -0.3vmax !important;
    transform: rotate(-5deg) !important;
  }

  /*** LEGS ***/

  .leg {
    width: 25%;
    height: 36%;
    top: 54%;
    left: 28%;
    transform-origin: center top;
  }

  .leg.right {
    animation: leg-right 20s ease-out 0s infinite;
  }

  @keyframes leg-right {
    0% {
      transform: rotate(-45deg);
    }
    20% {
      transform: rotate(10deg);
    }
    45% {
      transform: rotate(-45deg);
    }
    70% {
      transform: rotate(10deg);
    }
    100% {
      transform: rotate(-45deg);
    }
  }

  .leg.left {
    transform: rotate(-30deg);
    animation: leg-left 20s ease-out 0s infinite;
    transform-origin: 70% top;
    left: 45%;
    transform: rotate(-25deg);
    top: 56%;
    z-index: 2;
  }

  @keyframes leg-left {
    0% {
      transform: rotate(15deg);
    }
    20% {
      transform: rotate(-30deg);
    }
    45% {
      transform: rotate(15deg);
    }
    70% {
      transform: rotate(-30deg);
    }
    100% {
      transform: rotate(15deg);
    }
  }

  .leg .top,
  .leg .bot {
    width: 75%;
    height: 32%;
    left: -16%;
    top: -5%;
    transform-origin: right center;
    transform: rotate(-79deg);
    border-radius: 25% 10% 10% 25%;
    background: linear-gradient(-3deg, #888d90 0 65%, #c6c6c6 67% 100%);
  }

  .leg .bot {
    top: 25%;
    transform: rotate(-97deg);
    left: -28%;
    height: 31%;
  }

  .leg > div:before {
    background: #666b6e;
    height: 65%;
    width: 1vmax;
    right: -5%;
    border-radius: 80% 70% 35% 30%;
    transform: rotate(25deg);
    top: -6%;
  }

  .leg > div:after {
    background: #666b6e;
    height: 65%;
    width: 1vmax;
    top: 40%;
    right: 1%;
    transform: rotate(-10deg);
    border-radius: 30% 30% 80% 70%;
  }

  /*** FEET ***/

  .foot {
    background: linear-gradient(45deg, #888d90 0 55%, #c6c6c6 60% 100%);
    width: 55%;
    height: 45%;
    bottom: -10%;
    transform: rotate(-99deg);
    border-radius: 25% 55% 30% 30%;
    left: 20%;
    border-left: 0.65vmax solid #505050;
    box-sizing: border-box;
  }

  .foot:before {
    height: 50% !important;
    left: 78%;
    top: 22% !important;
    transform: rotate(13deg) !important;
  }

  .foot:after {
    height: 50% !important;
    left: 70%;
    top: 52% !important;
    transform: rotate(-5deg) !important;
    border-radius: 83% 25% 80% 70% !important;
  }

  .footprints {
    width: 100%;
    height: 15vmax;
    position: absolute;
    top: 50vmax;
    z-index: 1;
  }

  .footprints span {
    width: 4.5vmax;
    height: 2vmax;
    position: absolute;
    left: 74%;
    top: 2%;
    border-radius: 40% 30% 30% 40%;
    transform: rotateX(20deg) rotateZ(-2deg);
    background: repeating-linear-gradient(
      90deg,
      #c3c3c3 0 0.5vmax,
      #bdbdbd 0 1vmax
    );
    filter: blur(1px);
    opacity: 0.5;
    opacity: 0;
    animation: footprint 20s linear 0s infinite;
  }

  .footprints span + span {
    animation-delay: 5s;
    left: 45.75%;
    top: 3%;
  }

  .footprints span + span + span {
    animation-delay: 10s;
    left: 14.05%;
    top: 2%;
  }

  @keyframes footprint {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    21% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }
}

.bodyBox {
  width: 300px;
  padding: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #19191900;
  text-align: center;
  //box-shadow: 20px 25px 45px 15px;
  box-shadow: 10px 15px 45px 5px;
  z-index: 99999;
  border-radius: 10px;
  animation: bodyBox 1s forwards; /* 添加放大动画 */
  transform-origin: center center; /* 设置变换原点为中心 */

  .bodyBox1 {
    & > :nth-child(n + 1):nth-child(-n + 3) {
      margin-bottom: 20px;
    }

    & > h1 {
      color: white;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 20px;
    }

    .flax_x {
      display: flex;
      padding: 0 10px;

      :first-child {
        width: 120px;
      }
      :nth-child(2) {
        width: 75px;
        margin-left: 4px;
        border-radius: 4px;
      }
    }

    .tipsInfos {
      margin: 5px 0 15px 9px;
      text-align: left;
      color: #c5c5c5;
    }

    .foot-btn {
      margin-top: 14px;
      padding: 9px 24px !important;
    }
    .foot-btn:hover {
      border: 1px solid #1b1447;
    }

    .el-button:focus,
    .el-button:hover {
      color: #ffffff;
      border: 1px solid #ffffff;
      background-color: rgba(0, 0, 0, 0);
    }

    .forgetTxt {
      padding-top: 9px;
      color: #ccc;
    }
    .forgetTxt:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    .loadingClass {
      height: 100px;
      width: 100px;
      position: absolute !important;
      top: 200px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.8);
    }
    .el-loading-spinner .path {
      stroke: #ffffff;
    }
  }
  .bodyBox2 {
    text-align: left;
    color: #fff;
    font-size: 16px;
    .list {
      padding: 10px 0;
      .list-con {
        background: #fff;
        margin: 20px 0;
        color: #000;
        padding: 10px 8px;
        border-radius: 5px;
        &:hover {
          background: #3a8df7;
          color: #fff;
        }
      }
    }
  }
  .bodyBox3 {
    & > :first-child {
      font-size: 20px;
      font-weight: 500;
      color: white;
    }

    & > :nth-child(2) {
      margin-top: 10px;
      display: flex;
      color: white;

      .el-icon-arrow-left:before {
        font-size: 15px;
        padding-top: 2px;
        transform: translateY(-32px);
      }
      & > span {
        margin-left: 13px;
        transform: translateY(-33px);
      }
    }
    & > :nth-child(2):hover {
      cursor: pointer;
    }

    .forgetPSWContent {
      & > :first-child {
        margin-bottom: 20px;
      }

      .linePSW {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        /deep/ .el-input .el-input__inner {
          width: 115px;
          margin-left: 5px;
        }

        .getCode {
          width: 120px;
          display: block;
          text-align: center;
          height: 32px;
          line-height: 32px;
          color: #3a3a3aa6;
          margin-right: 10px;
          border-radius: 4px;
          cursor: pointer;
          background: white;
        }

        .getCode:hover {
          color: #ffffff;
          border: 1px solid #ffffff;
          background-color: rgba(0, 0, 0, 0);
        }
      }

      .foot-btn3 {
        margin-top: 10px;
        padding: 12px 71px;
        color: #606266;
      }
      .el-button:focus,
      .el-button:hover {
        color: #ffffff;
        border: 1px solid #ffffff;
        background-color: rgba(0, 0, 0, 0);
      }
    }

    .disableSpan {
      background: #d8dce6;
      color: #606266;
    }
  }

  .bodyBox4 {
    & > :first-child {
      font-size: 20px;
      font-weight: 500;
      color: white;
      margin-bottom: 20px;
    }
    .pswInfo {
      color: white;
      & > span {
        color: #409eff;
        cursor: pointer;
      }
      & > span:hover {
        text-decoration: underline;
      }
    }

    .foot-btn4 {
      margin-top: 25px;
      padding: 12px 71px;
      color: #606266;
    }
    .el-button:focus,
    .el-button:hover {
      color: #ffffff;
      border: 1px solid #ffffff;
      background-color: rgba(0, 0, 0, 0);
    }
  }
}
@keyframes bodyBox {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
  }
}

.foot_ddd {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #6e6e6e;
  z-index: 9999999999999999;
}
.foot_son {
  margin-right: 20px;
}

.go-back {
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  left: 15px;
  top: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue